module.exports = __webpack_public_path__ + "img/uv_resistance_tester.12b02379.jpg";